import "./index.css";
// import "./i18n";

import App from "./App";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Provider, useSelector } from "react-redux";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import TechnicalError from "./components/technicalerror/technicalerror";
import reportWebVitals from "./reportWebVitals";
import toolkit_store from "../src/store/redux-store/root_store";
import { LoggerService } from "./base/service/apiServices";
import { GetItemFromStorage } from "./custom_hooks/useStorage";
import { LocalStorage } from "./custom_hooks/localStorageKeys";
import { useVersionChecker } from "./custom_hooks/useVersionChecker";
import UpdateNotification from "./components/UpdateNotification/UpdateNotification";

<meta name="color-scheme" content="light dark"></meta>;

const removeLoader = () => {
  const loader = document.getElementById('contact_center_mainloader');
  if (loader) {
    loader.style.display = 'none'; 
  }
};
const AppWrapper = () => {
  const loginUserDetails = useSelector((state: any) => state?.loginUser?.loginUserDetails);
  const { callDetails }: any = useSelector((state: any) => state.callPopUpDetails);

  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);

  // Version checker - checks every 60 seconds for new deployments
  const {
    isNewVersionAvailable,
    reloadToNewVersion,
    dismissUpdate,
  } = useVersionChecker({
    checkInterval: 60 * 1000, // Check every 60 seconds
    onNewVersionAvailable: (version) => {
      console.log('New version available:', version);
    },
  });

  useEffect(() => {
    removeLoader();

    const handleError = (e: any) => {
      console.error("handleError indexFile capture")
      const target = e?.target || e?.srcElement;
      if (target?.tagName === "SCRIPT" && target?.src?.includes("/static/js/")) {
        console.error("Chunk load failed:", target?.src);
        window.location.reload();
      }
    };

    const handleRejection = (e: any) => {
      console.error("Unhandledrejection indexFile capture")
      if (e?.reason?.message?.includes("Loading chunk")) {
        console.error("Unhandled chunk load error:", e.reason);
        window.location.reload();
      }
    };

    window.addEventListener("error", handleError);
    window.addEventListener("unhandledrejection", handleRejection);

    return () => {
      window.removeEventListener("error", handleError);
      window.removeEventListener("unhandledrejection", handleRejection);
    };

  }, []);

  const onError =(error :any)=>{
     try {
      const domainId = userDetails?.domainId || userDetails?.domain_id || loginUserDetails?.domainId || loginUserDetails?.domain_id
      const userId = userDetails?.userId || loginUserDetails?.userId
      if(!domainId) return;
      const body ={
        message: error?.message || 'Error not capture',
        stack: "",
        url: window?.location?.href || 'Route not capture',
        domainId: `${domainId}_${userId}`,
      }
      LoggerService
        .post(body, '/logger_error_details')
        .catch((error)=> console.error("logger_error_details :: Error", error))

    } catch (error) {
      console.log(error)
    }
  }


  return (
    <ErrorBoundary fallbackRender={fallbackRender} onError={(error)=> onError(error)}>
      <>
        <App />

        {!callDetails?.length && <UpdateNotification
          isVisible={isNewVersionAvailable}
          onUpdate={reloadToNewVersion}
          onDismiss={dismissUpdate}
        />}
      </>
    </ErrorBoundary>
  );
};




ReactDOM.render(
    <Provider store={toolkit_store}>
        <BrowserRouter>
          <AppWrapper />
        </BrowserRouter>
    </Provider>,
  document.getElementById("root")
);
reportWebVitals();

function fallbackRender({ error, resetErrorBoundary }: any) {
  return (
    <div role="alert">
      <TechnicalError resetErrorBoundary={resetErrorBoundary}/>
    </div>
  );
}
